import { render, staticRenderFns } from "./ondemand.vue?vue&type=template&id=4cb83443&scoped=true&"
import script from "./ondemand.vue?vue&type=script&lang=js&"
export * from "./ondemand.vue?vue&type=script&lang=js&"
import style0 from "./ondemand.vue?vue&type=style&index=0&id=4cb83443&scoped=true&lang=css&"
import style1 from "./ondemand.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb83443",
  null
  
)

export default component.exports